import { render, staticRenderFns } from "./ImageWindow.vue?vue&type=template&id=ded72a86&scoped=true&"
import script from "./ImageWindow.vue?vue&type=script&lang=js&"
export * from "./ImageWindow.vue?vue&type=script&lang=js&"
import style0 from "./ImageWindow.vue?vue&type=style&index=0&id=ded72a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded72a86",
  null
  
)

export default component.exports